module.exports = __webpack_public_path__ + "img/-LV4xzSOcr5z4cwklCv4.04b5cb57.jpg";